import { STATUS_MAP, DEFAULT_TIMER_DURATION, STATUS_WITH_AUTO_TIMER, CARACTERES_MAXIMOS_SHOW_AUTO_TIMER } from './config.js';
import { handleIntervalTemporizadorToast } from './timer.js';
import { generateContentTemplate, generateProgressBarTemplate, generateToastTemplate } from './templates.js';
import { close_toast } from './close.js';

let contadorToast = 0;

export function exibe_mensagem_com_status(mensagem, status, title, temporizador = null, actionButton = null) {
  const statusConfig = STATUS_MAP[status] || STATUS_MAP.info;
  const { classe, titulo, icon, colorIcon } = statusConfig;

  let temporizadorToast;
  const mostraAutoTimer = STATUS_WITH_AUTO_TIMER.includes(status) && String(mensagem ?? '').length <= CARACTERES_MAXIMOS_SHOW_AUTO_TIMER;
  if (mostraAutoTimer) {
    temporizadorToast = DEFAULT_TIMER_DURATION;
  } else {
    temporizadorToast = temporizador;
  }

  const toastId = `toast-${++contadorToast}`;

  const content = generateContentTemplate({
    colorIcon,
    icon,
    title: title || titulo,
    mensagem,
    hasTimer: !!temporizadorToast,
    actionButton
  });

  const barraProgresso = temporizadorToast
    ? generateProgressBarTemplate(colorIcon)
    : '';

  const componente = generateToastTemplate({
    classe,
    content,
    barraProgresso,
    hasTimer: !!temporizadorToast,
    toastId
  });

  $('#alerts').append(componente);

  const toast = $(`#alerts .maino-toast[data-toast-id="${toastId}"]`);

  if (temporizadorToast) {
    return new Promise((resolve) => {
      const handleClose = () => {
        close_toast(toast).then(() => {
          resolve();
        });
      };

      const updateProgress = (percent) => {
        const progressBarInner = toast.find('.progress-bar-inner');
        if (progressBarInner.length) {
          progressBarInner.css('width', `${percent}%`);
        }
      };

      const timer = handleIntervalTemporizadorToast(
        temporizadorToast,
        updateProgress,
        handleClose
      );

      toast.data('timer', timer);
    });
  }
}
